module.exports = __webpack_public_path__ + "img/proyecto_16.ddaf276e.webp";